export const ausschreibungBundesligafinale2027 = {
  "id": "ausschreibung-bundesligafinale-2027",
  "title": "Ausrichter für das Bundesligafinale 2027 gesucht",
  "slug": "ausschreibung-bundesligafinale-2027",
  "publishedAt": "2026-10-25T09:00:00Z",
  "author": "Rugby-Bundesliga-Ausschuss",
  "language": "de",
  "readTime": "2 min",
  "tags": [
    "Rugby",
    "Bundesliga",
    "Ausschreibung",
    "Bundesligafinale",
    "Deutsche Meisterschaft",
    "1. Bundesliga",
    "Saison 2026/27"
  ],
  "excerpt": "Rugby Deutschland und der Rugby Bundesligaausschuss schreiben die Ausrichtung des Bundesligafinales 2027 aus. Am 19. Juni 2027 wird die Deutsche Meisterschaft im 15er Rugby der Herren entschieden. Bewerbungen sind bis zum 13. Dezember 2026 möglich.",
  "img": "/images/ausschreibung-bundesligafinale-2027.png",
  "blocks": [
    {
      "type": "paragraph",
      "content": "Rugby Deutschland und der Rugby Bundesligaausschuss (RBA) schreiben die Ausrichtung des Bundesligafinales 2027 aus. Am 19. Juni 2027 wird im Endspiel der 1. Bundesliga die Deutsche Meisterschaft im 15er Rugby der Herren entschieden. Interessierte Vereine und Organisationen können sich bis zum 13. Dezember 2026 bewerben."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Anforderungen an den Ausrichter"
    },
    {
      "type": "paragraph",
      "content": "Gesucht wird ein Ausrichter, der das Finale mit einem überzeugenden Veranstaltungskonzept und einer verlässlichen Organisation gestaltet. Voraussetzung ist ein geeignetes Stadion mit mindestens 2.000 Zuschauerplätzen. Dabei sind sowohl Stehplätze als auch Sitzplätze oder eine Kombination möglich. Eine eigene Finalteilnahme ist für die Bewerbung nicht erforderlich."
    },
    {
      "type": "paragraph",
      "content": "Das einzureichende Konzept soll zeigen, wie der Finaltag organisiert, beworben und finanziert wird. Dazu gehören insbesondere der Stadionbetrieb, die Bewirtung, das Rahmenprogramm sowie die Betreuung der Mannschaften und Ehrengäste. Auch Bewerbungen von Standorten außerhalb der regelmäßig genutzten Finalorte sind ausdrücklich willkommen."
    },
    {
      "type": "paragraph",
      "content": "Der Ausrichter übernimmt die Organisation der Veranstaltung und richtet einen verpflichtenden Online-Ticketverkauf ein. Die Aufnahme des Spiels organisiert Rugby Deutschland. Hierfür muss der Ausrichter unter anderem eine geeignete Kameraposition mit Blick auf die Haupttribüne ermöglichen."
    },
    {
      "type": "paragraph",
      "content": "Die Ausrichtungsgebühr beträgt 5.000 Euro zuzüglich Mehrwertsteuer. Alle verbindlichen Anforderungen, Leistungen und Regelungen zur Kostenverteilung sind in der vollständigen Ausschreibung beschrieben."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Bewerbung"
    },
    {
      "type": "paragraph",
      "content": "Bewerbungen sind bis zum 13. Dezember 2026 an office@rugbydeutschland.org zu senden. Als Betreff ist „Bewerbung Bundesligafinale 2027“ anzugeben. Neben dem Veranstaltungskonzept werden folgende Unterlagen benötigt:"
    },
    {
      "type": "list",
      "items": [
        "Stadionbeschreibung mit Kapazitätsnachweis",
        "Finanzierungsplan",
        "Angaben zum verantwortlichen Organisationsteam"
      ],
      "ordered": false
    },
    {
      "type": "paragraph",
      "content": "Ansprechpartner für Rückfragen ist der RBA-Vorsitzende Branimir Niko Colic."
    },
    {
      "type": "list",
      "items": [
        { "content": "Ausschreibung Bundesligafinale 2027 (PDF)", "url": "/documents/ausschreibung-bundesligafinale-2027.pdf" }
      ],
      "ordered": false
    },
    {
      "type": "footer",
      "content": "Artikel-Bild: © Fred Wolf"
    }
  ]
};
